import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "../services/routers";
export const trpc = createTRPCReact<AppRouter>();
